module.exports = __webpack_public_path__ + "img/regions.a5852719.svg";